<template>
    <div>
        <div v-if="! isLoadingBlade && ! showErrorStatus">
            <hr>
            <h3 class="text-uppercase">Application Preview</h3>
            <em class="mb-4 text-danger">
                Kindly check all information supplied, after submission changes can't be made...
            </em>
            <hr>

            <!-- This is profile details template here -->
            <ProfileDetails
                :application="application" 
                v-if="application"
            />

            <!-- This is Documents template here --> 
            <Documents
                :records="application.documents"
                v-if="application && application.documents"
            />

        </div>

        <div class="col-lg-12">
            <h3 class="mb-4 text-danger">
                Kindly check all information before submitting your application, changes can't be made after submission.
            </h3>
            <hr>
        </div>


        <div class="col-lg-12" v-if="isLoadingBlade">
            <div class="d-flex justify-content-center">
                <img :src="loadingBladeUrl" />
            </div>
        </div>

        <div class="col-lg-12 text-center" v-if='showErrorStatus && ! isLoadingBlade'>
            <base-alert :type="errorType">
                <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> --> 
                <span class="alert-inner--text">
                    <h2 class="text-white">{{errorMsg}}</h2>
                </span>
            </base-alert>
        </div>

        <div class="col-lg-12" v-if="! isLoadingBlade"> 
            <base-button
                type="danger"
                @click="showPreviousPage()"
            >
                <i class="fa fa-arrow-left"></i>
                Previous
            </base-button>

            <base-button
                type="success"
                class="right"
                @click="submitNow()"
            >
                <i class="fa fa-save"></i>
                {{ isloading ? 'Please Wait...' : 'Submit Now' }}
            </base-button>
        </div>

    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import ProfileDetails from './ProfileDetails';
    import Documents from './Documents.vue';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'RemediationSummary',
        props: ['displayDocuments', 'application', 'loadApplicantInfo', 'editRemediationApp'],
        components: {
            ProfileDetails,
            Documents
        },
        data() {
            return {
                isLoadingBlade: false,
                isloading: false,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null
            }
        },
        computed: {
            ...mapGetters(['loadingBladeUrl'])
        },
        methods: {
            ...mapActions(['submitRemediationApplication']),
            showPreviousPage() {// go to next page
                return this.displayDocuments(true);
            },
            submitNow() {// submit application
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                    if (result.value) {
                        return this.makeSubmitApiCall();// make api call


                        // if(this.resubmit) {
                        //     this.makeReSubmitApiCall(this.application.id);// make resubmit api call
                        // } else {
                        //     this.makeSubmitApiCall();// make api call
                        // }
                    }
                });
            },
            makeSubmitApiCall() {
                this.isloading = true;
                this.showInputErrorStatus = false;
                this.preloader();// show loading
                if(this.application.id) {// submit
                    this.submitRemediationApplication({ id : this.application.id}).then((res) => {
                        this.isloading = false;
                        if(res.status) {
                            swal.fire("Application Submitted!", res.msg, "success");
                            this.editRemediationApp(false);
                            this.loadApplicantInfo();
                        } else {
                            swal.fire("Error Ocurred!", res.msg, "warning");
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        let msg = "Server Failure!, kindly reload the page...";
                        swal.fire("Error Ocurred!", msg, "warning");
                    });
                }   else {
                    this.isloading = false;
                    let msg = "Server Failure!, kindly reload the page...";
                    swal.fire("Error Ocurred!", msg, "warning");
                }
            },
            makeReSubmitApiCall(id) {
                this.preloader(); // show loading
                this.reSubmitApplication(id).then((res) => {// get application record
                    if(res.status) {
                        swal.fire("Application Submitted!", res.msg, "success");
                        setTimeout(function() { window.location.href = '/applications'; }, 1000);
                    } else {
                        swal.fire("Error Occurred!", res.msg, "warning");
                    }
                }).
                catch(() => {
                    let msg = "Server Failure!, kindly reload the page...";
                    swal.fire("Server Failure!", msg, "warning");
                });
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right !important;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>